import React, { useEffect } from "react";
import Header from "../../ProviderList/Header";
 
import axios from "axios";
import toast from "react-hot-toast";
import { useProviderList } from "../../../hooks/useProviderList";
import SearchBar from "../../ProviderList/SearchBar";
import ProviderGrid from "../../ProviderList/ProviderGrid";



const ProviderList = ({ profileObject, setProfileObject }) => {
  const {searchTerm,setSearchTerm,providers,inputFocused,setInputFocused,dropdownRef,handleProviderSelect,handleBlur,handleProviderSubmit,loading } = useProviderList(setProfileObject);
  
  return (
    <div className="min-h-screen bg-slate-50 pb-10">
      <Header />
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl">
            Find your healthcare provider
          </h1>
          <p className="mx-auto mt-3 max-w-xl text-slate-600">
            Connect with trusted healthcare providers in your area. Quality care
            is just a search away.
          </p>
        </div>

        <div className="relative mb-8 flex max-w-6xl mx-auto justify-center gap-4">
           
          <SearchBar
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            onFocus={() => setInputFocused(true)}
            onBlur={handleBlur}
          />

   
          <button
            onClick={()=>handleProviderSubmit(profileObject)}
            className="hf-btn w-auto px-6"
          >
            Submit
          </button>
        </div>
 
        <ProviderGrid providers={providers} onSelect={handleProviderSelect} loading={loading} />
      </div>
    </div>
  );
};

export default ProviderList;
